import { stringify } from 'qs';
import request from '@/utils/request';
import func from '@/utils/Func';

export async function page(params) {
  return request(
    `/api/blade-interact/supervisionPlan/page?${stringify(params)}`,
  );
}

export async function save(params) {
  return request(`/api/blade-interact/supervisionScope/save`, {
    method: 'POST',
    body: params,
  });
}

export async function targetList(params) {
  return request(`/api/blade-system/target/page?${stringify(params)}`,
  );
}
export async function submit(params) {
  return request(`/api/blade-interact/supervisionPlan/saveplan`, {
    method: 'POST',
    body: params,
  });
}

export async function list(params) {
  return request(
    `/api/blade-interact/supervisionPlan/list?${stringify(params)}`,
  );
}

export async function remove(params) {
  return request(`/api/blade-interact/supervisionPlan/remove`, {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function update(params) {
  return request(`/api/blade-interact/supervisionPlan/updateplan`, {
    method: 'POST',
    body: params,
  });
}

export async function detail(params) {
  return request(
    `/api/blade-interact/supervisionPlan/detail?${stringify(params)}`,
  );
}

export async function getExpanInfo(params) {
  return request(
    `/api/blade-interact/supervisionCourseExpansion/getClassroomInfo?${stringify(params)}`,
  );
}